<template>
  <div class="form-progress-wrap edit-profile basic-info-wrap">
    <BaseLoading  :spinning="athleteLoading">
      <div class="container">
        <div class="steps-content">
          <div class="general-form-wrap teams-played-info-wrap box-wrapper">
            <div class="teams-played-form-wrap">
              <div class="heading">
                <h2 class="form-title">TEAMS YOU'VE PLAYED FOR</h2>
                <p class="header-info-wrapper">
                  (3 more teams can be added on profile creation)
                </p>
              </div>
              <div class="team-detail-wrap">
                <div
                  class="team-detail"
                  v-for="(team, index) in teamList"
                  :key="`team-${index}`"
                >
                  <a-row :gutter="16">
                    <a-col :sm="24">
                      <a-input v-model="team.name" placeholder="Team Name" />
                    </a-col>
                    <a-col :sm="24">
                      <a-select
                        show-search
                        option-filter-prop="children"
                        :filter-option="filterOption"
                        placeholder="Select Level"
                        v-model="team.level"
                      >
                        <a-select-option
                          v-for="(level, index) in levelList"
                          :key="`level=${index}`"
                          :value="level"
                          >{{ level }}</a-select-option
                        >
                      </a-select>
                    </a-col>
                    <a-col :sm="24">
                      <a-select
                        show-search
                        mode="multiple"
                        option-filter-prop="children"
                        :filter-option="filterOption"
                        placeholder="Select Position"
                        :value="team.positionIds"
                        @change="value => (team.positionIds = value)"
                      >
                        <a-select-option
                          v-for="(position, index) in positionList"
                          :key="`positions-${index}`"
                          :value="position._id"
                          >{{ position.name }}</a-select-option
                        >
                      </a-select>
                    </a-col>
                    <a-col :sm="24">
                      <a-input
                        v-model="team.coachName"
                        placeholder="Coach Name"
                      />
                    </a-col>
                    <a-col :sm="24">
                      <a-input
                        v-model="team.coachEmail"
                        placeholder="Coach's Email Address"
                      />
                    </a-col>
                    <a-col :sm="24">
                      <a-input
                        v-model="team.coachPhone"
                        placeholder="Coach's Phone Number"
                      />
                    </a-col>
                  </a-row>
                  <div class="button-wrap">
                    <span v-if="team._id === null">
                      <a-button
                        type="primary"
                        icon="file-add"
                        class="save-button"
                        v-on:click="saveNewTeam(team)"
                        >Save</a-button
                      >
                    </span>
                    <span v-else>
                      <a-button
                        type="primary"
                        icon="file-add"
                        class="save-button"
                        v-on:click="editTeam(team)"
                        >Update</a-button
                      >
                    </span>
                  </div>
                </div>
              </div>
              <a-form-item>
                <a-button
                  type="primary"
                  @click="handleNextSubmit"
                  class="next-button first-save-button"
                  >Save And Continue</a-button
                >
                <a-button
                  type="primary"
                  @click="handleStepSkip"
                  class="next-button second-skip-button"
                  >Skip</a-button
                >
              </a-form-item>
            </div>
          </div>
        </div>
      </div>
    </BaseLoading>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import { RepositoryFactory } from "@/repositories/RepositoryFactory";
const TaxonomyRepository = RepositoryFactory.get("taxonomy");
const athleteRepository = RepositoryFactory.get("athlete");
const STORE_KEY = "playerStore";
const ATHLETE_STORE_KEY = "athleteStore";

export default {
  name: "TeamsInfo",
  props: ["id"],
  data() {
    return {
      teamlength: 1,
      levelList: ["Collegiate" ,"High School", "Club", "Recreation"],
      positionList: [],
      teamList: [
        {
          _id: null,
          name: "",
          level: [],
          position: [],
          coachName: "",
          email: "",
          coachPhone: "",
          positionIds: []
        },
        {
          _id: null,
          name: "",
          level: [],
          position: [],
          coachName: "",
          email: "",
          coachPhone: "",
          positionIds: []
        }
      ]
    };
  },
  created() {
    this.dispatcher();
    TaxonomyRepository.getTaxonomyValues("Player Position").then(response => {
      this.positionList = response.data.taxonomy.values;
    });
  },
  computed: {
    ...mapGetters({
      ProfileData: `${STORE_KEY}/getViewProfileData`,
      athlete: `${ATHLETE_STORE_KEY}/athlete`,
      athleteLoading: `${ATHLETE_STORE_KEY}/athleteLoading`
    }),
    athleteId() {
      return this.$route.params.id;
    }
  },
  methods: {
    validateForm() {
      return true;
    },
    async dispatcher() {
      await this.$store.dispatch(`${ATHLETE_STORE_KEY}/getAthlete`, {
        id: this.id
      });
    },
    ...mapActions({
      addPlayerTeams: `${STORE_KEY}/addPlayerTeams`
    }),
    addNewTeam() {
      if (this.teamlength < 5) {
        let newdata = {
          _id: null,
          name: "",
          level: [],
          position: [],
          coachName: "",
          email: "",
          coachPhone: "",
          positionIds: []
        };
        this.teamlength = this.teamlength + 1;
        this.teamList.push(newdata);
      }
    },
    editTeam(team) {
      let toSend = {
        name: team.name,
        level: team.level,
        position: team.positionIds,
        coachName: team.coachName,
        coachEmail: team.coachEmail,
        coachPhone: team.coachPhone,
        slug: "teamplayed"
      };
      if (Object.values(toSend).includes("")) {
        this.$notification.error({
          message: "Error",
          description: "Please enter all the values to edit"
        });
        return;
      }
      athleteRepository.editPlayerTeams(toSend, team._id).then(async () => {
        this.$message.success("Team updated successfully!");
        await this.$store.dispatch(`${ATHLETE_STORE_KEY}/getAthlete`, {
          id: this.id
        });
      });
    },
    saveNewTeam(team) {
      let toSend = {
        atheleteMainProfileId: this.id,
        name: team.name,
        level: team.level,
        position: team.positionIds,
        coachName: team.coachName,
        coachEmail: team.coachEmail,
        coachPhone: team.coachPhone
      };
      if (Object.values(toSend).includes("")) {
        this.$notification.error({
          message: "Error",
          description: "Please enter all the values to save"
        });
        return;
      }
      athleteRepository.postPlayerTeams(toSend).then(async () => {
        this.$message.success("New Team added successfully!");
        await this.$store.dispatch(`${ATHLETE_STORE_KEY}/getAthlete`, {
          id: this.id
        });
        if (this.athlete.teamPlayedData.length === 2) {
          await this.$store.dispatch(`${ATHLETE_STORE_KEY}/updateAthlete`, {
            id: this.id,
            registerPageCompleted: 6,
            message: "Teams Played  Added to Profile"
          });
        }
      });
    },
    deleteTeam(team) {
      athleteRepository.deletePlayerTeams(team._id).then(async response => {
        this.$message.success("Team deleted successfully!");
        TaxonomyRepository.getTaxonomyValues("Player Position").then(
          response => {
            this.positionList = response.data.taxonomy.values;
          }
        );
        await this.$store.dispatch(`${ATHLETE_STORE_KEY}/getAthlete`, {
          id: this.id
        });
      });
    },
    removeTeam(index) {
      this.teamlength = this.teamlength - 1;
      this.teamList.splice(index, 1);
    },
    async handleNextSubmit() {
      await this.$store.dispatch(`${ATHLETE_STORE_KEY}/updateAthlete`, {
        id: this.athleteId,
        registerPageCompleted: 6,
        slug: "athlete",
        message: "Teams Played  Added to Profile"
      });
      await this.$store.dispatch(`${ATHLETE_STORE_KEY}/getAthlete`, {
        id: this.athleteId
      });
      this.$emit("save", this.athlete.registerPageCompleted);
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleStepSkip() {
      this.$emit("save", 6);
    }
  },
  watch: {
    athlete(newVal, _) {
      if (newVal.hasOwnProperty("teamPlayedData")) {
        if (newVal.teamPlayedData.length > 0) {
          this.teamList = [
            ...newVal.teamPlayedData,
            {
              _id: null,
              name: "",
              level: [],
              position: [],
              coachName: "",
              email: "",
              coachPhone: "",
              positionIds: []
            },
            {
              _id: null,
              name: "",
              level: [],
              position: [],
              coachName: "",
              email: "",
              coachPhone: "",
              positionIds: []
            }
          ].splice(0, 2);
          this.teamList = this.teamList.map(item => ({
            ...item,
            positionIds: item.position.map(pos => pos._id)
          }));
          this.teamlength = newVal.teamPlayedData.length;
        }
      }
    }
  }
};
</script>
<style lang="scss">
.teams-played-form-wrap {
  .team-detail-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    .team-detail {
      width: 28%;
      margin: 10px 10px;
      padding: 40px 25px 20px;
      background: #ffffff;
      .team-info {
        font-size: 16px;
        font-weight: 600;
        color: #181818;
        text-align: center;
        padding-bottom: 20px;
      }
      .ant-col {
        margin-bottom: 15px;
      }
      .ant-select {
        width: 100%;
      }
      .button-wrap {
        padding-top: 10px;
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-between;
        .save-button {
          background: #2a328a;
          border-color: #2a328a;
        }
      }
    }
    .add-team-wrap {
      position: relative;
      &::after {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.15);
        z-index: 1;
      }
      .team-content {
        opacity: 0.4;
      }
      .add-new-button {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        cursor: pointer;
        .text-detail {
          text-align: center;
          font-size: 34px;
          // text-transform: uppercase;
          font-weight: 800;
          margin-bottom: 20px;
          color: #000;
        }
      }
    }
    .ant-select-selection {
      min-height: 40px;
      height: 100% !important;
    }
    .ant-select-selection--multiple {
      .ant-select-selection__rendered {
        > ul {
          > li {
            height: 30px;
            margin-top: 4px;
            margin-right: 6px;
            line-height: 30px;
            border-color: grey;
            background: none;
            .ant-select-selection__choice__content {
              font-weight: 500;
            }
          }
        }
      }
    }
  }
  .ant-btn-icon-only {
    margin-left: 30px;
  }
}
@media only screen and (max-width: 991px) {
  .teams-played-form-wrap {
    .team-detail-wrap {
      .team-detail {
        width: 45%;
        margin: 10px 10px;
        padding: 40px 25px 20px;
        background: #ffffff;
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .teams-played-form-wrap {
    .team-detail-wrap {
      .team-detail {
        margin: 8px 8px;
        padding: 30px 20px 15px;
        .team-info {
          font-size: 14px;
          padding-bottom: 15px;
        }
      }
    }
  }
}
@media only screen and (max-width: 991px) {
  .teams-played-form-wrap {
    .team-detail-wrap {
      .team-detail {
        width: 100%;
        margin: 10px 10px;
        padding: 40px 25px 20px;
        background: #ffffff;
      }
    }
  }
}
@media only screen and (max-width: 575px) {
  .teams-played-form-wrap {
    .heading {
      margin-bottom: 40px;
      .form-title {
        margin-bottom: 2rem !important;
        .team-detail-wrap {
          .team-detail {
            width: 100%;
            margin: 10px 10px;
            padding: 40px 25px 20px;
            background: #ffffff;
          }
        }
      }
    }
  }
}
</style>
